import { AxiosInstance } from 'axios'

import { OrganisationProfileService } from '@percent/domain/organisation-profile'
import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'

export const organisationProfileService = ({
  percentClient
}: {
  percentClient: AxiosInstance
}): OrganisationProfileService => ({
  getOrganisationProfiles: params => percentClient.get(`${baseUrl}organisation-profiles`, { params }),
  getOrganisationProfile: ({ organisationId }) => percentClient.get(`${baseUrl}organisation-profiles/${organisationId}`)
})
